import React, { useEffect, useRef, useState } from "react";
import ReactPlayer from "react-player";
import { useLocation, useNavigate } from "react-router-dom";
import apiServiceHandler from "../../service/apiService";
import toastr from "toastr";

const Ignition = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [ignition, setIgnition] = useState("");

  const isEditable = pathname.split("/").includes("edit");

  const textAreaRef = useRef(null);

  useEffect(() => {
    if (textAreaRef.current) {
      textAreaRef.current.focus();
    }
  }, []);

  const saveIgnition = async (e) => {
    e.preventDefault();

    if (!ignition) {
      toastr.error("Please fill the Ignition");
      return;
    }

    const payload = {
      statement: ignition,
      progress: 100,
    };

    try {
      const prevMessagePage = localStorage.getItem("prevMessagePage") === "true";
      if (prevMessagePage) {
        navigate("/message-page")
      } else {
        navigate("/onboarding-driver");
      }
      const res = await apiServiceHandler("POST", "api/ignition", payload);
    } catch (error) {
      console.log("Failed to save credo" + error);
    }
  };

  useEffect(() => {
    const fetchIgnition = async () => {
      try {
        const res = await apiServiceHandler("GET", "api/ignition", {});
        if (res.status) {
          setIgnition(res.data.statement);
        }
      } catch (error) {
        console.log("Failed to fetch data");
      }
    };
    fetchIgnition();
  }, []);

  return (
    <main className="auth">
      <div className="auth-layout">
        <div className="auth-view">
          <div className="driver-auth-view__container">
            <div className="driver-view">
              <div className="credo-heading">IGNITION STATEMENT</div>
              <form className="driver-form">
                <div className="driver-view__field">
                  <ReactPlayer
                    url="https://stgmp4folder.s3.us-west-1.amazonaws.com/STG90+Compressed/stg90-03-ignition-statement.mp4"
                    config={{
                      vimeo: {
                        playerOptions: {
                          title: true,
                          byline: false,
                          portrait: false,
                        },
                      },
                    }}
                    controls={true}
                    width="100%"
                    height="100%"
                  />
                </div>

                <textarea
                  type="text"
                  className="credo-input"
                  ref={textAreaRef}
                  value={ignition}
                  onChange={(e) => setIgnition(e.target.value)}
                />

                <div
                  style={{ display: "flex", gap: "1rem", alignItems: "center" }}
                >
                  <button
                    type="submit"
                    className="driver-btn"
                    onClick={saveIgnition}
                  >
                    <span className="driver-button__label">
                      {isEditable ? "UPDATE" : "SAVE"}
                    </span>
                  </button>
                  <div
                    style={{
                      marginTop: "2rem",
                      color: "#fff",
                      cursor: "pointer",
                    }}
                    onClick={() => navigate("/onboarding-driver")}
                  >
                    skip
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Ignition;
